module.exports = __webpack_public_path__ + "static/under-the-big-top-d0c1c92c81ed94f679e7707cd67d2a10.jpg";